import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined

const EditPatient = () => {
    const { id } = useParams(); // Get patient ID from route
    const navigate = useNavigate();

    // State to store form data
    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        gender: 'Male',
        dob: '',
        loyalty_card: false,
        card_no: '',
        status: 'Active',
        anniversary: '',
        spouse_name: '',
        gst_no: '',
        territory: '',
        address: '',
        country: '',
        state: '',
        city: '',
        pin_code: '',
        longitude: '',
        latitude: '',
    });

    // Fetch patient details
    useEffect(() => {
        fetch(`${BASE_URL}patients/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    setFormData(data.data); // Set form data with fetched patient details
                } else {
                    alert('Error fetching patient data');
                }
            })
            .catch((error) => console.error('Error fetching patient:', error));
    }, [id]);

    // Handle input change
    const handleInputChange = (event) => {
        const { name, value, type, checked } = event.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    // Handle form submission
    const handleSubmit = (event) => {
        event.preventDefault();

        fetch(`${BASE_URL}patients/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Patient updated successfully!');
                    navigate('/PatientMasterList'); // Navigate to patient list
                } else {
                    alert('Error updating patient. Please try again.');
                }
            })
            .catch((error) => console.error('Error updating patient:', error));
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Patient</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb"></ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Form Section */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            className="form-control"
                                            value={formData.name}
                                            onChange={handleInputChange}
                                            placeholder="Enter patient's name"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="phone" className="form-label">Phone</label>
                                        <input
                                            type="text"
                                            id="phone"
                                            name="phone"
                                            className="form-control"
                                            value={formData.phone}
                                            onChange={handleInputChange}
                                            placeholder="Enter phone number"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            className="form-control"
                                            value={formData.email}
                                            onChange={handleInputChange}
                                            placeholder="Enter email"
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="gender" className="form-label">Gender</label>
                                        <select
                                            id="gender"
                                            name="gender"
                                            className="form-control"
                                            value={formData.gender}
                                            onChange={handleInputChange}
                                            required
                                        >
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="dob" className="form-label">Date of Birth</label>
                                        <input
                                            type="date"
                                            id="dob"
                                            name="dob"
                                            className="form-control"
                                            value={formData.dob}
                                            onChange={handleInputChange}
                                            required
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="loyalty_card" className="form-label">Loyalty Card</label>
                                        <input
                                            type="checkbox"
                                            id="loyalty_card"
                                            name="loyalty_card"
                                            checked={formData.loyalty_card}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                    {formData.loyalty_card && (
                                        <div className="mb-3">
                                            <label htmlFor="card_no" className="form-label">Card Number</label>
                                            <input
                                                type="text"
                                                id="card_no"
                                                name="card_no"
                                                className="form-control"
                                                value={formData.card_no}
                                                onChange={handleInputChange}
                                                placeholder="Enter card number"
                                            />
                                        </div>
                                    )}
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            id="address"
                                            name="address"
                                            className="form-control"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            placeholder="Enter address"
                                            required
                                        />
                                    </div>
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Patient</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditPatient;
